import _ from 'lodash';
import moment from 'moment-timezone';
import i18n from '~/utils/i18n';
import { availableFilters as genericFilters, visibleFields } from './generic.js';

export const endpoint = 'drafts/search';

export const allFields = {
  name: {
    sortable: false,
    formatter: (value, key, data) => _.get(data, 'data.name', null),
    translateColumn: () => i18n.t('draft_field.title.name'),
  },
  customer: {
    sortable: false,
    formatter: (value, key, data) => _.get(data, 'data.customer.name', null),
    translateColumn: () => i18n.t('draft_field.title.company'),
  },
  customer_remote_id: {
    sortable: false,
    formatter: (value, key, data) => _.get(data, 'data.customer.remote_id', null),
    translateColumn: () => i18n.t('draft_field.title.customer-remote-id'),
  },
  objective: {
    sortable: false,
    formatter: (value, key, data) => _.get(data, 'data.details.objective', null),
    translateColumn: () => i18n.t('draft_field.title.objective'),
  },
  channels: {
    sortable: false,
    formatter: (value, key, data) => _.get(data, 'data.details.channels', null),
    translateColumn: () => i18n.t('draft_field.title.channels'),
  },
  budget: {
    sortable: false,
    formatter: (value, key, data) => _.get(data, 'data.details.budget', null),
    translateColumn: () => i18n.t('draft_field.title.budget'),
  },
  code: {
    sortable: false,
    formatter: (value, key, data) => _.get(data, 'campaign.code', null),
    translateColumn: () => i18n.t('draft_field.title.code'),
  },
  created_at: {
    sortable: true,
    translateColumn: () => i18n.t('draft_field.title.created'),
    translateCell: (data) => {
      if (data !== null && moment(data).isValid()) {
        return i18n.t('fn.date', { timestamp: data });
      }
      return null;
    },
  },
};

export function availableFields(disabledFields) {
  return visibleFields(disabledFields, allFields);
}

export const enabledFields = [
  'code',
  'name',
  'customer',
  'customer_remote_id',
  'objective',
  'channels',
  'budget',
];

export const enabledFieldsMD = [
  'code',
  'name',
  'customer',
  'customer_remote_id',
  'objective',
  'channels',
  'budget',
];

export const enabledFieldsSM = [
  'code',
  'name',
  'customer',
  'customer_remote_id',
  'objective',
  'channels',
  'budget',
];

// Format (required fields for all filters)
// [
//   {
//     name: 'Start date', // Filter name visible to user
//     slug: 'startDate', // Filter slug which is sent to ADAPI
//     type: FILTER_DATE_FROM_TO, // Filter type
//     default: { from: null, to: null }, // Filter default value (used when resetting data)
//     getData: null, // Endpoint to get filter values from API
//     formatGetData: null, // Function to parse getData() response from API
//     toObject: value => value, // Function to query paramater to object
//     toFilter: value => value, // Function to parse object to filter request
//   },
// ]
export const availableFilters = [
  ...genericFilters,
];



// WEBPACK FOOTER //
// ./src/gotu-vue-common/src/search-models/draft.js